export const getInitialState = () => ({
    fetchStatus: "initial",
    addProductFetchStatus: "initial",
    cartDetails: undefined,
    error: undefined
});
